import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";
import { toast } from "react-toastify";
import './AddLeague.css';

const API = process.env.REACT_APP_API;

function AddLeague() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { token } = useAuth();

  const [league, setLeague] = useState({
    name: "",
    code: "",
    structureFile: "",
    stages: [],
    defaultStageId: null
  });

  const [newStage, setNewStage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLeague((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && !["image/jpeg", "image/png", "image/jpg"].includes(file.type)) {
      toast.error("אנא בחר תמונה בלבד (JPG או PNG)");
      return;
    }
    setLeague(prev => ({ ...prev, structureFile: file }));
  };

  const handleAddStage = () => {
    if (!newStage.trim()) return;
    setLeague(prev => ({
      ...prev,
      stages: [...prev.stages, { name: newStage }],
    }));
    setNewStage("");
  };

  const handleDeleteStage = (index) => {
    setLeague(prev => ({
      ...prev,
      stages: prev.stages.filter((_, i) => i !== index),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!league.code)
      {
        toast.error("קוד ליגה הינו חובה");
        return
      }
    else if (!league.name)
      {
        toast.error("שם ליגה הינו חובה");
        return
      }

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("code", league.code);
      formDataToSend.append("name", league.name);
      formDataToSend.append("stages", JSON.stringify(league.stages));
      formDataToSend.append("defaultStageId", league.defaultStageId);
      if (league.structureFile instanceof File) {
        formDataToSend.append("structureFile", league.structureFile);
      }

      await axios.post(`${API}/api/leagues`, formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`, // 👈 חובה
        },
      });

      toast.success("הליגה נוספה בהצלחה!");
      navigate("/leagues"); // חזרה לעמוד הליגות
    } catch (err) {
        console.error("שגיאה בהוספת ליגה:", err);
        toast.error("שגיאה בהוספת ליגה");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="Add-league-wrapper">
      <div className="Add-league-container">
        <h2>הוספת ליגה חדשה</h2>

        <div className="form-group">
          <label><strong>קוד ליגה:</strong></label>
          <input
            type="number"
            name="code"
            placeholder="1, 2, 3..."
            value={league.code}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label><strong>שם הליגה:</strong></label>
            <input
              type="text"
              name="name"
              placeholder="לדוגמה: מרכז א"
              value={league.name}
              onChange={handleChange}
              required
            />
        </div>

        {/* <div className="form-group">
          <label>קובץ דירוג:</label>
          <input
            type="text"
            name="rankingFile"
            placeholder=""
            value={formData.rankingFile}
            onChange={handleChange}
          />
        </div> */}

        <div className="form-group">
          <label><strong>מבנה ליגה (תמונה):</strong></label>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
          />
        </div>

        <h3>שלבים</h3>
        <ul className="stages-list">
          {league.stages.map((stage, index) => (
            <li key={index}className="stage-item">
              {/* בחירת ברירת מחדל */}
              {league.stages.length > 1 ? (
              <input
                type="radio"
                name="defaultStage"
                checked={league.defaultStageId === stage._id}
                onChange={() =>
                  setLeague((prev) => ({ ...prev, defaultStageId: stage._id }))
                }
                title="תצוגת ברירת מחדל"
              /> ) : (
              " "
              )}
              <span>{stage.name}</span>
              <button onClick={() => handleDeleteStage(index)} className="delete-stage">❌</button>
            </li>
          ))}
        </ul>

        <div className="add-league-add-stage">
          <input
            type="text"
            value={newStage}
            onChange={(e) => setNewStage(e.target.value)}
            placeholder="שם שלב חדש"
          />
          <button onClick={handleAddStage}>➕ הוסף שלב</button>
        </div>

        <div className="buttons">
          <button
            onClick={handleSubmit}
            className="save-btn"
            disabled={loading}
          >
            {loading ? "שומר..." : "הוספה"}
          </button>
          <button onClick={() => navigate("/leagues")} className="cancel-btn">↩ חזרה</button>
        </div>
      </div>
    </div>
  );
}

export default AddLeague;
